export function attachMenuBackground(canvas: HTMLCanvasElement): () => void {
  const ctx = canvas.getContext('2d');
  if (!ctx) return () => {};

  const nodes: { x: number; y: number; vx: number; vy: number }[] = [];
  for (let i = 0; i < 24; i++) {
    nodes.push({
      x: Math.random(),
      y: Math.random(),
      vx: (Math.random() - 0.5) * 0.0004,
      vy: (Math.random() - 0.5) * 0.0004,
    });
  }

  let raf = 0;
  let t = 0;

  const draw = () => {
    t += 0.016;
    const w = canvas.width = canvas.clientWidth * devicePixelRatio;
    const h = canvas.height = canvas.clientHeight * devicePixelRatio;
    ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
    const cw = canvas.clientWidth;
    const ch = canvas.clientHeight;
    const grad = ctx.createLinearGradient(0, 0, cw, ch);
    grad.addColorStop(0, '#1a3a62');
    grad.addColorStop(1, '#243f6b');
    ctx.fillStyle = grad;
    ctx.fillRect(0, 0, cw, ch);

    for (const n of nodes) {
      n.x += n.vx;
      n.y += n.vy;
      if (n.x < 0 || n.x > 1) n.vx *= -1;
      if (n.y < 0 || n.y > 1) n.vy *= -1;
    }

    ctx.strokeStyle = 'rgba(56, 201, 244, 0.12)';
    ctx.lineWidth = 1;
    for (let i = 0; i < nodes.length; i++) {
      for (let j = i + 1; j < nodes.length; j++) {
        const a = nodes[i]!;
        const b = nodes[j]!;
        const dx = (a.x - b.x) * cw;
        const dy = (a.y - b.y) * ch;
        if (dx * dx + dy * dy < 180 * 180) {
          ctx.beginPath();
          ctx.moveTo(a.x * cw, a.y * ch);
          ctx.lineTo(b.x * cw, b.y * ch);
          ctx.stroke();
        }
      }
    }

    for (const n of nodes) {
      const pulse = 0.6 + Math.sin(t * 2 + n.x * 10) * 0.4;
      ctx.fillStyle = `rgba(244, 125, 187, ${0.35 * pulse})`;
      ctx.beginPath();
      ctx.arc(n.x * cw, n.y * ch, 3 + pulse * 2, 0, Math.PI * 2);
      ctx.fill();
    }

    raf = requestAnimationFrame(draw);
  };

  raf = requestAnimationFrame(draw);
  return () => cancelAnimationFrame(raf);
}
